import { PageLayout } from '@components/common';
import { Skeleton } from '@fourthwall/components';
import React from 'react';
export const TierSkeleton = () => (React.createElement(PageLayout, { rightContent: React.createElement(Skeleton, null,
        React.createElement(Skeleton.Shape, { width: "100%", height: 95 })), leftContent: React.createElement(Skeleton, { gap: 16 },
        React.createElement(Skeleton.Shape, { width: 110, height: 28 }),
        React.createElement(Skeleton.Shape, { width: "100%", height: 54 }),
        React.createElement(Skeleton.Shape, { width: "100%", height: 78 }),
        React.createElement(Skeleton.Shape, { width: "100%", height: 100 })) },
    React.createElement("div", { style: { marginBottom: 32 } },
        React.createElement(Skeleton, { gap: 14 },
            React.createElement(Skeleton.Shape, { width: 150, height: 24 }),
            React.createElement(Skeleton.Shape, { width: 300, height: 45 })))));
